function deepTrim<T>(obj: T): T {
  if (typeof obj === 'string') {
    return obj.trim() as unknown as T;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => deepTrim(item)) as unknown as T;
  }

  if (typeof obj === 'object' && obj !== null) {
    const trimmedObj: Record<string, any> = {};
    for (const key in obj) {
      trimmedObj[key] = deepTrim(obj[key]);
    }
    return trimmedObj as T;
  }

  return obj;
};

export default deepTrim;